import {
  CategoryFilterOption,
  ContractTypeOption,
  Country,
  LivingSpaceRange,
  PriceRange,
  PropertySpaceRange,
  RadiusFilterOption,
  Region,
  RoomCountRange,
  SortDropdownOption,
  SubcategoryOptionsMap,
  UsageSpaceRange,
} from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum FilterActions {
  UpdateFilter = '[Filter] Update Filter',
  UpdateFilterConfig = '[Filter] Update Filter Config',
  ResetAll = '[Filter] Reset All',
}

export interface UpdateActionsProps {
  mainCategory?: CategoryFilterOption;
  subcategory?: SubcategoryOptionsMap;
  price?: PriceRange;
  roomCount?: RoomCountRange;
  livingSpace?: LivingSpaceRange;
  usageSpace?: UsageSpaceRange;
  propertySpace?: PropertySpaceRange;
  radius?: RadiusFilterOption;
  contractType?: ContractTypeOption;
  regions?: Region[];
  sort?: SortDropdownOption;
  countries?: Country[];
  isResidia?: boolean;
}

export const updateFilter = createAction(
  FilterActions.UpdateFilter,
  props<UpdateActionsProps>()
);

export const updateFilterConfig = createAction(
  FilterActions.UpdateFilterConfig
);

export const resetAllFilters = createAction(FilterActions.ResetAll);
